import axios from "axios";
import { Dispatch } from "redux";
import {
    VehicleRecommendationTypes,
    GET_VEHICLE_RECOMMENDATION,
    GET_VEHICLE_RECOMMENDATION_SUCCESS,
    GET_VEHICLE_RECOMMENDATION_FAILURE,

    GET_VEHICLE_RECOMMENDATION_BYTOKEN,
    GET_VEHICLE_RECOMMENDATION_BYTOKEN_SUCCESS,
    GET_VEHICLE_RECOMMENDATION_BYTOKEN_FAILURE,

} from "../types/vehicleRecommendationTypes";


const API = axios.create({ baseURL: process.env.REACT_APP_API_URL });

API.defaults.withCredentials = true;


export const getRecommendedVehicle = () => async (dispatch: Dispatch<VehicleRecommendationTypes>) => {
    try {
        dispatch({ type: GET_VEHICLE_RECOMMENDATION, payload: [] });
        const response = await API.get("/recommended-vehicle", { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
     });

        if (response.status) {
             dispatch({ type: GET_VEHICLE_RECOMMENDATION_SUCCESS, payload: response.data });
        } else {
            dispatch({ type: GET_VEHICLE_RECOMMENDATION_FAILURE, payload: response.data.message });
        }
    } catch (error: any) {
        dispatch({ type: GET_VEHICLE_RECOMMENDATION_FAILURE, payload: error?.response?.data?.message });
    }
};



export const getRecommendedVehicleByToken = (vin: string , token: string) => async (dispatch: Dispatch) => {

    dispatch({ type: GET_VEHICLE_RECOMMENDATION_BYTOKEN, payload: [], });

    try {
        const response = await API.get("/recommendedVehicle/getByToken", { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        params: {
            vin: vin,
            token: token 
          }
         });

          
        if (response.status) {
            dispatch({ type: GET_VEHICLE_RECOMMENDATION_BYTOKEN_SUCCESS, payload: response.data });
        } else {
            dispatch({ type: GET_VEHICLE_RECOMMENDATION_BYTOKEN_FAILURE, payload: response.data.message });
        }

    } catch (error: any) {
        dispatch({ type: GET_VEHICLE_RECOMMENDATION_BYTOKEN_FAILURE, payload: error.response?.data?.message || "Failed to fetch vehicles", });
    }
};








